import React, { useState, useEffect } from 'react';
import { getAbmCodeUsage, addNewCodes } from 'shared/services/abmApi';
import { AbmCodeUsage, AddCodeResult } from 'shared/models/api/models';
import { Button, Input } from 'reactstrap';


interface IUsageDataProps {
    codeUsage: undefined | AbmCodeUsage;
}

const UsageView = (props: IUsageDataProps) => {
    return (
        <>
            {props.codeUsage != undefined ?
                <>
                    <div>
                        Codes available: {props.codeUsage.available}
                    </div>

                    <div>
                        Codes used: {props.codeUsage.used}
                    </div>
                </>
                :
                <>
                    <div>Loading...</div>
                </>
            }
        </>
    );
}

interface IAddCodesFormProps {
    addCodes: () => void;
    newCodes: string;
    setNewCodes: React.Dispatch<React.SetStateAction<string>>;
}

const AddCodesForm = (props: IAddCodesFormProps) => {
    return (
        <>
            <div>
                Add new codes - Must be full redemption URLs
            </div>
            <div>
                <Input
                    type="textarea"
                    placeholder='Paste from "Code Redemption Link" column in code spreadsheet'
                    className="mb-2"
                    value={props.newCodes}
                    onChange={(e) => props.setNewCodes(e.currentTarget.value)}
                    rows={10}
                />
            </div>
            <div>
                <Button onClick={props.addCodes}>Add Codes</Button>
            </div>
        </>
    );
}

interface IAddCodesResultsProps {
    codesAddedResult: AddCodeResult;
    setCodesAddedResult: React.Dispatch<React.SetStateAction<AddCodeResult | undefined>>;
}

const AddCodesResults = (props: IAddCodesResultsProps) => {
    return (
        <>
            <div>
                Results
            </div>
            <div>
                Added: {props.codesAddedResult.added}
            </div>
            {props.codesAddedResult.duplicate > 0 &&
                <div>
                    Duplicates: {props.codesAddedResult.duplicate}
                </div>
            }
            {props.codesAddedResult.invalid > 0 &&
                <div>
                    Invalid: {props.codesAddedResult.invalid}
                </div>
            }
            {props.codesAddedResult.error && props.codesAddedResult.error.length > 0 &&
                <div>
                    Error: {props.codesAddedResult.error}
                </div>
            }
            <div>
                <Button onClick={() => props.setCodesAddedResult(undefined)}>Add More Codes</Button>
            </div>
        </>
    );
}

const AppleAppCodesPage = () => {
    const [codeUsage, setCodeUsage] = useState(undefined as undefined | AbmCodeUsage);
    const [codesAddedResult, setCodesAddedResult] = useState(undefined as undefined | AddCodeResult);
    const [newCodes, setNewCodes] = useState("");

    const addCodes = () => {
        let codesArray = newCodes.split(/\r?\n/);
        addNewCodes(codesArray).then(codesAdded);
    }

    const codesAdded = async (result: AddCodeResult) => {
        setCodesAddedResult(result);
        setNewCodes("");
        getAbmCodeUsage().then(setCodeUsage);
    }

    useEffect(() => {
        let mounted = true;
        const mount = async () => {
            const usage = await getAbmCodeUsage();

            if (mounted) {
                setCodeUsage(usage);
            }
        };

        mount();
        return () => { mounted = false };
    }, []);

    return (
        <div>
            <UsageView codeUsage={codeUsage} />

            <hr />

            {codesAddedResult ?
                <AddCodesResults codesAddedResult={codesAddedResult} setCodesAddedResult={setCodesAddedResult} />
                :
                <AddCodesForm addCodes={addCodes} newCodes={newCodes} setNewCodes={setNewCodes} />
            }
        </div>
    );
};

export default AppleAppCodesPage;
